import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const BulletListButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('bulletList'),
      isDisabled: !editor.can().toggleBulletList(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBulletList().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="list-ul" />}
         title={_js('Add a bulleted list')}
         shortcut={'shift+8'}
      />
   );
};
